import React, { useState } from 'react';
import TacticCard from './TacticCard';
import { FaRocket, FaDownload, FaShare, FaCheck } from 'react-icons/fa';

const TacticsDisplayStep = ({ tactics, onExport, onShare, onImplement, onComplete }) => {
    const [selectedPlatform, setSelectedPlatform] = useState('all');
    const [selectedBudget, setSelectedBudget] = useState('all');

    const platforms = ['all', 'whatsapp', 'instagram', 'facebook', 'email', 'google'];
    const budgets = ['all', 'low', 'medium', 'high'];

    const getPlatformLabel = (platform) => {
        switch (platform) {
            case 'all':
                return 'Todas las Plataformas';
            case 'whatsapp':
                return 'WhatsApp';
            case 'instagram':
                return 'Instagram';
            case 'facebook':
                return 'Facebook';
            case 'email':
                return 'Email Marketing';
            case 'google':
                return 'Google Ads';
            default:
                return platform;
        }
    };

    const getBudgetLabel = (budget) => {
        switch (budget) {
            case 'all':
                return 'Todos los Presupuestos';
            case 'low':
                return 'Bajo (€100-500)';
            case 'medium':
                return 'Medio (€500-2000)';
            case 'high':
                return 'Alto (€2000+)';
            default:
                return budget;
        }
    };

    const filteredTactics = tactics?.filter(tactic => {
        const platformMatch = selectedPlatform === 'all' || tactic.platform?.toLowerCase().includes(selectedPlatform);
        const budgetMatch = selectedBudget === 'all' || tactic.budget?.toLowerCase().includes(selectedBudget);
        return platformMatch && budgetMatch;
    }) || [];

    return (
        <div className="space-y-8">
            {/* Header */}
            <div className="text-center">
                <div className="flex justify-center mb-4">
                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
                        <FaRocket className="text-green-500 text-2xl" />
                    </div>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                    ¡Tu Plan de Marketing Está Listo!
                </h2>
                <p className="text-gray-600">
                    Hemos generado {tactics?.length || 0} tácticas específicas para implementar tu estrategia
                </p>
            </div>

            {/* Action Buttons */}
            <div className="bg-white rounded-lg shadow-lg p-6">
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <button
                        onClick={onExport}
                        className="flex items-center justify-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                    >
                        <FaDownload className="mr-2" />
                        Exportar Plan
                    </button>
                    <button
                        onClick={onShare}
                        className="flex items-center justify-center px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                    >
                        <FaShare className="mr-2" />
                        Compartir
                    </button>
                    <button
                        onClick={onComplete}
                        className="flex items-center justify-center px-6 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
                    >
                        <FaCheck className="mr-2" />
                        Completar
                    </button>
                </div>
            </div>

            {/* Filters */}
            <div className="bg-white rounded-lg shadow-lg p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-4">Filtrar Tácticas</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Plataforma
                        </label>
                        <select
                            value={selectedPlatform}
                            onChange={(e) => setSelectedPlatform(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        >
                            {platforms.map(platform => (
                                <option key={platform} value={platform}>
                                    {getPlatformLabel(platform)}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Presupuesto
                        </label>
                        <select
                            value={selectedBudget}
                            onChange={(e) => setSelectedBudget(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        >
                            {budgets.map(budget => (
                                <option key={budget} value={budget}>
                                    {getBudgetLabel(budget)}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>

            {/* Tactics List */}
            <div className="space-y-6">
                <div className="flex items-center justify-between">
                    <h3 className="text-lg font-bold text-gray-900">
                        Tácticas ({filteredTactics.length})
                    </h3>
                    <div className="text-sm text-gray-600">
                        Mostrando {filteredTactics.length} de {tactics?.length || 0} tácticas
                    </div>
                </div>

                {filteredTactics.length === 0 ? (
                    <div className="text-center py-12 bg-gray-50 rounded-lg">
                        <p className="text-gray-600">No se encontraron tácticas con los filtros seleccionados</p>
                        <button
                            onClick={() => {
                                setSelectedPlatform('all');
                                setSelectedBudget('all');
                            }}
                            className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                        >
                            Limpiar Filtros
                        </button>
                    </div>
                ) : (
                    <div className="space-y-6">
                        {filteredTactics.map((tactic, index) => (
                            <TacticCard
                                key={tactic.id}
                                tactic={tactic}
                                onImplement={onImplement}
                                onSave={() => {/* Implementar guardar */ }}
                                position={index + 1}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default TacticsDisplayStep; 